import * as tslib_1 from "tslib";
import collectedOptions from '../config/collectedOptions';
import { computed } from 'mobx';
var allOptions = computed(function () {
    var allOptions = [];
    collectedOptions().forEach(function (category) {
        category.subcategories.forEach(function (subcategory) {
            allOptions = allOptions.concat(subcategory.options.map(function (option) { return (tslib_1.__assign({}, option, { categoryKey: category.key, subcategoryKey: subcategory.key })); }));
        });
    });
    return allOptions;
});
export default (function () { return allOptions.get(); });
//# sourceMappingURL=getAllOptions.js.map